CountryService = ->
  get: ->
    countries = [
      {name: "Japan 日本", value: "JPN"}
      {name: "Afghanistan", value: "AFG"}
      {name: "Albania",     value: "ALB" }
      {name: "Algeria",     value: "DZA"}
      {name: "Andorra",     value: "AND"}
      {name: "Angola",      value: "AGO"}
      {name: "Antigua and Barbuda", value: "ATG"}
      {name: "Argentina",           value: "ARG"}
      {name: "Armenia",   value: "ARM"}
      {name: "Australia", value: "AUS"}
      {name: "Austria", value: "AUT"}
      {name: "Azerbaijan", value: "AZE"}
      {name: "Bahamas", value: "BHS"}
      {name: "Bahrain", value: "BHR"}
      {name: "Bangladesh", value: "BGD"}
      {name: "Barbados",   value: "BRB"}
      {name: "Belarus",    value: "BLR"}
      {name: "Belgium", value: "BEL"}
      {name: "Belize", value: "BLZ"}
      {name: "Benin", value: "BEN"}
      {name: "Bhutan", value: "BTN"}
      {name: "Bolivia", value: "BOL"}
      {name: "Bosnia and Herzegovina", value: "BIH"}
      {name: "Botswana", value: "BWA"}
      {name: "Brazil", value: "BRA"}
      {name: "Brunei Darussalam", value: "BRN"}
      {name: "Bulgaria", value: "BGR"}
      {name: "Burkina Faso", value: "BFA"}
      {name: "Burundi", value: "BDI"}
      {name: "Cambodia", value: "KHM"}
      {name: "Cameroon", value: "CMR"}
      {name: "Canada", value: "CAN"}
      {name: "Cape Verde", value: "CPV"}
      {name: "Central African Republic", value: "CAF"}
      {name: "Chad", value: "TCD"}
      {name: "Chile", value: "CHL"}
      {name: "China", value: "CHN"}
      {name: "Chinese Taipei", value: "TWN"}
      {name: "Colombia", value: "COL"}
      {name: "Comoros", value: "COM"}
      {name: "Congo", value: "COG"}
      {name: "Costa Rica", value: "CRI"}
      {name: "Cote d'Ivoire", value: "CIV"}
      {name: "Croatia", value: "HRV"}
      {name: "Cuba", value: "CUB"}
      {name: "Cyprus", value: "CYP"}
      {name: "Czech Republic", value: "CZE"}
      {name: "Democratic People's of Korea", value: "PRK"}
      {name: "Denmark", value: "DNK"}
      {name: "Djibouti", value: "DJI"}
      {name: "Dominica", value: "DMA"}
      {name: "Dominican Republic", value: "DOM"}
      {name: "Ecuador", value: "ECU"}
      {name: "Egypt", value: "EGY"}
      {name: "El Salvador", value: "SLV"}
      {name: "Equatorial Guinea", value: "GNQ"}
      {name: "Eritrea", value: "ERI"}
      {name: "Estonia", value: "EST"}
      {name: "Ethiopia", value: "ETH"}
      {name: "Federated States of Micronesia", value: "FSM"}
      {name: "Fiji", value: "FJI"}
      {name: "Finland", value: "FIN"}
      {name: "France", value: "FRA"}
      {name: "Gabon", value: "GAB"}
      {name: "Gambia", value: "GMB"}
      {name: "Georgia", value: "GEO"}
      {name: "Germany", value: "DEU"}
      {name: "Ghana", value: "GHA"}
      {name: "Greece", value: "GRC"}
      {name: "Greenland", value: "GRL"}
      {name: "Grenada", value: "GRD"}
      {name: "Guatemala", value: "GTM"}
      {name: "Guinea", value: "GIN"}
      {name: "Guinea-Bissau", value: "GNB"}
      {name: "Guyana", value: "GUY"}
      {name: "Haiti", value: "HTI"}
      {name: "Holy See (Vatican City State)", value: "VAT"}
      {name: "Honduras", value: "HND"}
      {name: "Hungary", value: "HUN"}
      {name: "Iceland", value: "ISL"}
      {name: "India", value: "IND"}
      {name: "Indonesia", value: "IDN"}
      {name: "Iraq", value: "IRQ"}
      {name: "Ireland", value: "IRL"}
      {name: "Islamic Republic of Iran", value: "IRN"}
      {name: "Israel", value: "ISR"}
      {name: "Italy", value: "ITA"}
      {name: "Jamaica", value: "JAM"}
      {name: "Jordan", value: "JOR"}
      {name: "Kazakhstan", value: "KAZ"}
      {name: "Kenya", value: "KEN"}
      {name: "Kiribati", value: "KIR"}
      {name: "Kuwait", value: "KWT"}
      {name: "Kyrgyzstan", value: "KGZ"}
      {name: "Lao People's Democratic Republic", value: "LAO"}
      {name: "Latvia", value: "LVA"}
      {name: "Lebanon", value: "LBN"}
      {name: "Lesotho", value: "LSO"}
      {name: "Liberia", value: "LBR"}
      {name: "Libyan Arab Jamahiriya", value: "LBY"}
      {name: "Liechtenstein", value: "LIE"}
      {name: "Lithuania", value: "LTU"}
      {name: "Luxembourg", value: "LUX"}
      {name: "Madagascar", value: "MDG"}
      {name: "Malawi", value: "MWI"}
      {name: "Malaysia", value: "MYS"}
      {name: "Maldives", value: "MDV"}
      {name: "Mali", value: "MLI"}
      {name: "Malta", value: "MLT"}
      {name: "Marshall Islands", value: "MHL"}
      {name: "Mauritania", value: "MRT"}
      {name: "Mauritius", value: "MUS"}
      {name: "Mexico", value: "MEX"}
      {name: "Monaco", value: "MCO"}
      {name: "Mongolia", value: "MNG"}
      {name: "Morocco", value: "MAR"}
      {name: "Mozambique", value: "MOZ"}
      {name: "Myanmar", value: "MMR"}
      {name: "Namibia", value: "NAM"}
      {name: "Nauru", value: "NRU"}
      {name: "Nepal", value: "NPL"}
      {name: "Netherlands", value: "NLD"}
      {name: "Netherlands Antilles", value: "ANT"}
      {name: "New Zealand", value: "NZL"}
      {name: "Nicaragua", value: "NIC"}
      {name: "Niger", value: "NER"}
      {name: "Nigeria", value: "NGA"}
      {name: "Norway", value: "NOR"}
      {name: "Oman", value: "OMN"}
      {name: "Pakistan", value: "PAK"}
      {name: "Palau", value: "PLW"}
      {name: "Panama", value: "PAN"}
      {name: "Papua New Guinea", value: "PNG"}
      {name: "Paraguay", value: "PRY"}
      {name: "Peru", value: "PER"}
      {name: "Philippines", value: "PHL"}
      {name: "Poland", value: "POL"}
      {name: "Portugal", value: "PRT"}
      {name: "Qatar", value: "QAT"}
      {name: "Republic of Korea", value: "KOR"}
      {name: "Republic of Moldova", value: "MDA"}
      {name: "Romania", value: "ROU"}
      {name: "Russian Federation", value: "RUS"}
      {name: "Rwanda", value: "RWA"}
      {name: "Saint Kitts and Nevis", value: "KNA"}
      {name: "Saint Lucia", value: "LCA"}
      {name: "Saint Vincent and the Grenadines", value: "VCT"}
      {name: "Samoa", value: "WSM"}
      {name: "San Mario", value: "SMR"}
      {name: "Sao Tome and Principe", value: "STP"}
      {name: "Saudi Arabia", value: "SAU"}
      {name: "Senegal", value: "SEN"}
      {name: "Seychelles", value: "SYC"}
      {name: "Sierra Leone", value: "SLE"}
      {name: "Singapore", value: "SGP"}
      {name: "Slovakia", value: "SVK"}
      {name: "Slovenia", value: "SVN"}
      {name: "Solomon Islands", value: "SLB"}
      {name: "Somalia", value: "SOM"}
      {name: "South Africa", value: "ZAF"}
      {name: "Spain", value: "ESP"}
      {name: "Sri Lanka", value: "LKA"}
      {name: "Sudan", value: "SDN"}
      {name: "Suriname", value: "SUR"}
      {name: "Swaziland", value: "SWZ"}
      {name: "Sweden", value: "SWE"}
      {name: "Switzerland", value: "CHE"}
      {name: "Syrian Arab Republic", value: "SYR"}
      {name: "Tajikistan", value: "TJK"}
      {name: "Thailand", value: "THA"}
      {name: "the former Yugoslav Republic Macedonia", value: "MKD"}
      {name: "Togo", value: "TGO"}
      {name: "Tonga", value: "TON"}
      {name: "Trinidad and Tobago", value: "TTO"}
      {name: "Tunisia", value: "TUN"}
      {name: "Turkey", value: "TUR"}
      {name: "Turkmenistan", value: "TKM"}
      {name: "Tuvalu", value: "TUV"}
      {name: "Uganda", value: "UGA"}
      {name: "Ukraine", value: "UKR"}
      {name: "United Arab Emirates", value: "ARE"}
      {name: "United Kingdom", value: "GBR"}
      {name: "United Republic of Tanzania", value: "TZA"}
      {name: "United States", value: "USA"}
      {name: "Uruguay", value: "URY"}
      {name: "Uzbekistan", value: "UZB"}
      {name: "Vanuatu", value: "VUT"}
      {name: "Venezuela", value: "VEN"}
      {name: "Viet Nam", value: "VNM"}
      {name: "Yemen", value: "YEM"}
      {name: "Zambia", value: "ZMB"}
      {name: "Zimbabwe", value: "ZWE"}
    ]
    countries

module.exports = CountryService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/country-service.coffee